import { render } from "./AddUrls.vue?vue&type=template&id=22593f84"
import script from "./AddUrls.vue?vue&type=script&lang=js"
export * from "./AddUrls.vue?vue&type=script&lang=js"

import "./AddUrls.vue?vue&type=style&index=0&id=22593f84&lang=css"

import exportComponent from "E:\\backup\\Programowanie\\scheduler\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__